import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ==============================|| TYPES ||============================== //

interface SnackBarAction {
    text: string;
    url: string;
}

interface SnackBarState {
    snackBarMessage: string;
    snackBarMessageType: 'success' | 'error';
    snackBarOpen: boolean;
    snackBarAction: SnackBarAction | null;
}

// initial state
const initialState: SnackBarState = {
    snackBarMessage: '',
    snackBarMessageType: 'success',
    snackBarOpen: false,
    snackBarAction: null
};

// ==============================|| SLICE - SNACKBAR MESSAGES ||============================== //

const snackBarMessagesSlice = createSlice({
    name: 'snackBarMessages',
    initialState,
    reducers: {
        addSnackBarMessage(state, action: PayloadAction<string>) {
            if (state.snackBarMessage === '') {
                state.snackBarMessage = action.payload;
            } else {
                state.snackBarMessage = state.snackBarMessage + '\n' + action.payload;
            }
        },

        changeSnackBarType(state, action: PayloadAction<'success' | 'error'>) {
            state.snackBarMessageType = action.payload;
        },

        clearSnackBarMessage(state) {
            state.snackBarMessage = '';
            state.snackBarMessageType = 'success';
            state.snackBarAction = null;
        },

        setSnackBarOpen(state, action: PayloadAction<boolean>) {
            state.snackBarOpen = action.payload;
        },

        setSnackBarAction(state, action: PayloadAction<SnackBarAction | null>) {
            state.snackBarAction = action.payload;
        }
    }
});

export default snackBarMessagesSlice.reducer;

export const { addSnackBarMessage, clearSnackBarMessage, changeSnackBarType, setSnackBarOpen, setSnackBarAction } =
    snackBarMessagesSlice.actions;
